module.exports = __webpack_public_path__ + "static/media/heart-full.44d83407.svg";